<template>
  <ion-page>
    <LoadingScreen v-if="loadingSave" />

    <div class="header">
      <div class="flex">
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M30 8.00016C30 6.93929 29.5786 5.92188 28.8284 5.17173C28.0783 4.42158 27.0609 4.00016 26 4.00016H25V3.02828C25 2.49015 24.5862 2.02828 24.0481 2.0014C23.9129 1.99489 23.7778 2.01589 23.6509 2.06314C23.5241 2.1104 23.4081 2.18291 23.3102 2.27629C23.2122 2.36967 23.1341 2.48198 23.0808 2.60641C23.0275 2.73083 23 2.86479 23 3.00015V4.00016H9V3.02828C9 2.49015 8.58625 2.02828 8.04813 2.0014C7.91292 1.99489 7.77779 2.01589 7.65094 2.06314C7.52409 2.1104 7.40815 2.18291 7.31015 2.27629C7.21215 2.36967 7.13413 2.48198 7.08082 2.60641C7.02751 2.73083 7.00001 2.86479 7 3.00015V4.00016H6C4.93913 4.00016 3.92172 4.42158 3.17157 5.17173C2.42143 5.92188 2 6.93929 2 8.00016V8.75016C2 8.81647 2.02634 8.88006 2.07322 8.92694C2.12011 8.97382 2.1837 9.00016 2.25 9.00016H29.75C29.8163 9.00016 29.8799 8.97382 29.9268 8.92694C29.9737 8.88006 30 8.81647 30 8.75016V8.00016Z"
            fill="#B61E3F"
          />
          <path
            d="M2 26C2 27.0609 2.42143 28.0783 3.17157 28.8284C3.92172 29.5786 4.93913 30 6 30H26C27.0609 30 28.0783 29.5786 28.8284 28.8284C29.5786 28.0783 30 27.0609 30 26V11.1875C30 11.1378 29.9802 11.0901 29.9451 11.0549C29.9099 11.0198 29.8622 11 29.8125 11H2.1875C2.13777 11 2.09008 11.0198 2.05492 11.0549C2.01975 11.0901 2 11.1378 2 11.1875V26ZM23.5 13C23.7967 13 24.0867 13.088 24.3334 13.2528C24.58 13.4176 24.7723 13.6519 24.8858 13.926C24.9993 14.2001 25.0291 14.5017 24.9712 14.7926C24.9133 15.0836 24.7704 15.3509 24.5607 15.5607C24.3509 15.7704 24.0836 15.9133 23.7926 15.9712C23.5017 16.0291 23.2001 15.9994 22.926 15.8858C22.6519 15.7723 22.4176 15.58 22.2528 15.3334C22.088 15.0867 22 14.7967 22 14.5C22 14.1022 22.158 13.7206 22.4393 13.4393C22.7206 13.158 23.1022 13 23.5 13ZM23.5 18C23.7967 18 24.0867 18.088 24.3334 18.2528C24.58 18.4176 24.7723 18.6519 24.8858 18.926C24.9993 19.2001 25.0291 19.5017 24.9712 19.7926C24.9133 20.0836 24.7704 20.3509 24.5607 20.5607C24.3509 20.7704 24.0836 20.9133 23.7926 20.9712C23.5017 21.0291 23.2001 20.9993 22.926 20.8858C22.6519 20.7723 22.4176 20.58 22.2528 20.3334C22.088 20.0867 22 19.7967 22 19.5C22 19.1022 22.158 18.7206 22.4393 18.4393C22.7206 18.158 23.1022 18 23.5 18ZM18.5 13C18.7967 13 19.0867 13.088 19.3334 13.2528C19.58 13.4176 19.7723 13.6519 19.8858 13.926C19.9993 14.2001 20.0291 14.5017 19.9712 14.7926C19.9133 15.0836 19.7704 15.3509 19.5607 15.5607C19.3509 15.7704 19.0836 15.9133 18.7926 15.9712C18.5017 16.0291 18.2001 15.9994 17.926 15.8858C17.6519 15.7723 17.4176 15.58 17.2528 15.3334C17.088 15.0867 17 14.7967 17 14.5C17 14.1022 17.158 13.7206 17.4393 13.4393C17.7206 13.158 18.1022 13 18.5 13ZM18.5 18C18.7967 18 19.0867 18.088 19.3334 18.2528C19.58 18.4176 19.7723 18.6519 19.8858 18.926C19.9993 19.2001 20.0291 19.5017 19.9712 19.7926C19.9133 20.0836 19.7704 20.3509 19.5607 20.5607C19.3509 20.7704 19.0836 20.9133 18.7926 20.9712C18.5017 21.0291 18.2001 20.9993 17.926 20.8858C17.6519 20.7723 17.4176 20.58 17.2528 20.3334C17.088 20.0867 17 19.7967 17 19.5C17 19.1022 17.158 18.7206 17.4393 18.4393C17.7206 18.158 18.1022 18 18.5 18ZM18.5 23C18.7967 23 19.0867 23.088 19.3334 23.2528C19.58 23.4176 19.7723 23.6519 19.8858 23.926C19.9993 24.2001 20.0291 24.5017 19.9712 24.7926C19.9133 25.0836 19.7704 25.3509 19.5607 25.5607C19.3509 25.7704 19.0836 25.9133 18.7926 25.9712C18.5017 26.0291 18.2001 25.9993 17.926 25.8858C17.6519 25.7723 17.4176 25.58 17.2528 25.3334C17.088 25.0867 17 24.7967 17 24.5C17 24.1022 17.158 23.7206 17.4393 23.4393C17.7206 23.158 18.1022 23 18.5 23ZM13.5 18C13.7967 18 14.0867 18.088 14.3334 18.2528C14.58 18.4176 14.7723 18.6519 14.8858 18.926C14.9994 19.2001 15.0291 19.5017 14.9712 19.7926C14.9133 20.0836 14.7704 20.3509 14.5607 20.5607C14.3509 20.7704 14.0836 20.9133 13.7926 20.9712C13.5017 21.0291 13.2001 20.9993 12.926 20.8858C12.6519 20.7723 12.4176 20.58 12.2528 20.3334C12.088 20.0867 12 19.7967 12 19.5C12 19.1022 12.158 18.7206 12.4393 18.4393C12.7206 18.158 13.1022 18 13.5 18ZM13.5 23C13.7967 23 14.0867 23.088 14.3334 23.2528C14.58 23.4176 14.7723 23.6519 14.8858 23.926C14.9994 24.2001 15.0291 24.5017 14.9712 24.7926C14.9133 25.0836 14.7704 25.3509 14.5607 25.5607C14.3509 25.7704 14.0836 25.9133 13.7926 25.9712C13.5017 26.0291 13.2001 25.9993 12.926 25.8858C12.6519 25.7723 12.4176 25.58 12.2528 25.3334C12.088 25.0867 12 24.7967 12 24.5C12 24.1022 12.158 23.7206 12.4393 23.4393C12.7206 23.158 13.1022 23 13.5 23ZM8.5 18C8.79667 18 9.08668 18.088 9.33335 18.2528C9.58003 18.4176 9.77229 18.6519 9.88582 18.926C9.99935 19.2001 10.0291 19.5017 9.97118 19.7926C9.9133 20.0836 9.77044 20.3509 9.56066 20.5607C9.35088 20.7704 9.08361 20.9133 8.79264 20.9712C8.50166 21.0291 8.20006 20.9993 7.92597 20.8858C7.65189 20.7723 7.41762 20.58 7.2528 20.3334C7.08797 20.0867 7 19.7967 7 19.5C7 19.1022 7.15804 18.7206 7.43934 18.4393C7.72064 18.158 8.10218 18 8.5 18ZM8.5 23C8.79667 23 9.08668 23.088 9.33335 23.2528C9.58003 23.4176 9.77229 23.6519 9.88582 23.926C9.99935 24.2001 10.0291 24.5017 9.97118 24.7926C9.9133 25.0836 9.77044 25.3509 9.56066 25.5607C9.35088 25.7704 9.08361 25.9133 8.79264 25.9712C8.50166 26.0291 8.20006 25.9993 7.92597 25.8858C7.65189 25.7723 7.41762 25.58 7.2528 25.3334C7.08797 25.0867 7 24.7967 7 24.5C7 24.1022 7.15804 23.7206 7.43934 23.4393C7.72064 23.158 8.10218 23 8.5 23Z"
            fill="#B61E3F"
          />
        </svg>
        <div style="margin-left: 16px" variant="page-title">
          <span v-if="$route.params.eventId == 'new'">Esemény létrehozása</span>
          <span v-else>Esemény szerkesztése</span>
        </div>
      </div>
      <button
        style="text-decoration: underline"
        variant="white"
        @click="() => (goBackModalVisible = true)"
      >
        <span>Bezárás</span>
      </button>
    </div>

    <ion-content>
      <div class="container">
        <div class="event-page-sidebar">
          <EventPageSidebar :mode="formMode" :formFields="formTracker" />
        </div>
        <div class="event-page-content">
          <div style="margin-bottom: 48px" variant="page-title">
            <span v-if="$route.params.eventId == 'new'"
              >1. Új esemény részletei</span
            >
            <span v-else>1. Az esemény részletei</span>
          </div>

          <EventForm
            :error="eventError"
            v-if="
              !loadingEvent &&
              !loadingWinery &&
              winery &&
              !loadingConfig &&
              config
            "
            :triggerSubmit="triggerSubmit"
            :initialData="event"
            :winery="winery"
            :config="config"
            :handleSubmit="handleSubmit"
            :handleChange="handleChange"
            :onRemoveCover="handleRemoveCover"
            @modechange="(mode) => (formMode = mode)"
          />
        </div>
      </div>

      <!-- NEW EVENT MODAL -->
      <modal-component @close="toEventsPage()" v-if="newEventModalVisible">
        <div
          style="
            display: flex;
            flex-direction: column;
            align-items: center;
            margin: 24px 48px;
          "
        >
          <svg
            width="144"
            height="144"
            viewBox="0 0 144 144"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="144" height="144" rx="72" fill="#D6244A" />
            <path
              d="M80 97.27C80 97.27 78 98 72 98C66 98 62.75 96 60 94H52C49.8783 94 47.8434 93.1571 46.3431 91.6569C44.8429 90.1566 44 88.1217 44 86V80C44 77.8783 44.8429 75.8434 46.3431 74.3431C47.8434 72.8429 49.8783 72 52 72H55.75C56.4368 71.9962 57.1114 71.8175 57.71 71.4807C58.3086 71.1439 58.8115 70.6601 59.1712 70.075C59.1712 70.075 60.25 67.7262 63.5 62.0975C66.75 56.4688 73 48 74 46C77.625 46 79.375 48.75 78.25 51.9637C76.965 55.6375 75.2863 58.7613 74.8175 62.85C74.75 63.4475 75.21 64.35 75.8112 64.35L92 65.625"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M92 73.875L82 73.625C79.5 73.395 78 72.075 78 69.875C78 67.675 79.75 66.27 82 66.125L92 65.625C94.2 65.625 96 67.675 96 69.875V69.8962C95.9944 70.9534 95.5705 71.9654 94.8209 72.7109C94.0714 73.4565 93.0572 73.875 92 73.875Z"
              stroke="white"
              stroke-width="2"
              stroke-miterlimit="10"
            />
            <path
              d="M96 82L82 81.75C79.75 81.645 78 80.1988 78 78C78 75.7987 79.75 74.3925 82 74.25L96 74C97.0599 74.0033 98.0754 74.4258 98.8248 75.1752C99.5742 75.9246 99.9967 76.9401 100 78V78C99.9967 79.0599 99.5742 80.0754 98.8248 80.8248C98.0754 81.5742 97.0599 81.9967 96 82V82Z"
              stroke="white"
              stroke-width="2"
              stroke-miterlimit="10"
            />
            <path
              d="M90 98L82 97.625C79.375 97.395 78 96.2 78 94C78 91.8 79.8 90.25 82 90.25L90 90C91.06 90.003 92.0756 90.4253 92.8251 91.1749C93.5747 91.9244 93.997 92.94 94 94V94C93.997 95.06 93.5747 96.0756 92.8251 96.8251C92.0756 97.5747 91.06 97.997 90 98V98Z"
              stroke="white"
              stroke-width="2"
              stroke-miterlimit="10"
            />
            <path
              d="M94 90L82 89.75C79.625 89.645 78 88.2 78 86C78 83.8 79.625 82.395 82 82.25L94 82C95.06 82.003 96.0756 82.4253 96.8251 83.1749C97.5747 83.9244 97.997 84.94 98 86V86C97.997 87.06 97.5747 88.0756 96.8251 88.8251C96.0756 89.5747 95.06 89.997 94 90Z"
              stroke="white"
              stroke-width="2"
              stroke-miterlimit="10"
            />
          </svg>
          <p variant="navigation-bold" style="margin-top: 32px">
            Sikeresen
            {{ newEventModalVisible == "draft" ? "mentetted" : "közzétetted" }}
            a(z)
          </p>
          <h1
            variant="page-title"
            style="color: var(--color-blue-04-1); margin: 0"
          >
            {{ eventName }}
          </h1>
          <p variant="navigation-bold">nevű eseményt</p>
          <p variant="navigation-bold" style="margin-top: 8px; margin-bottom: 8px;" v-if="newEventModalVisible !== 'draft'">
            Küldjük az esemény jegyvásárlási linkjét:
          </p>
          <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 8px;" v-if="newEventModalVisible !== 'draft'"><a :href="`https://www.orszagosbortura.hu/esemenyek/${eventNID}`" target="_blank">{{
              `https://www.orszagosbortura.hu/esemenyek/${eventNID}`
            }}</a><copy-button iconSize="24" :tooltipText="'jegyvásárlási link másolása'" :text="`https://www.orszagosbortura.hu/esemenyek/${eventNID}`"></copy-button></div>
          <p variant="navigation-bold" style="margin-top: 8px" v-if="newEventModalVisible !== 'draft'">
            Másold ki vagy kattints a másolás szimbólumra!
          </p>
        </div>
      </modal-component>

      <!-- CHANGES ARE NOT SAVED MODAL -->
      <modal-component
        @close="() => (goBackModalVisible = false)"
        v-if="goBackModalVisible"
      >
        <div
          style="
            display: flex;
            flex-direction: column;
            align-items: center;
            margin: 24px 48px;
          "
        >
          <p variant="navigation-bold" style="text-align: center">
            Ha az elvetés gombra kattintasz, az eddigi beállításaid nem kerülnek
            mentésre ennél az eseménynél!
          </p>
          <div style="margin-top: 24px">
            <button
              style="margin-right: 16px"
              variant="white"
              @click="() => $router.go(-1)"
            >
              Elvetés
            </button>
            <button
              variant="secondary"
              @click="
                () => {
                  triggerSubmit++;
                  goBackModalVisible = false;
                }
              "
            >
              Mentés piszkozatként
            </button>
          </div>
        </div>
      </modal-component>
    </ion-content>
  </ion-page>
</template>

<script>
import { IonPage, IonContent } from "@ionic/vue";
import { useRoute, useRouter } from "vue-router";
import EventForm from "./EventForm.vue";
import EventPageSidebar from "./EventPageSidebar.vue";
import eventApi from "../../api/event";
import useEvent from "../../hooks/useEvent";
import useWinery from "../../hooks/useWinery";
import useConfig from "../../hooks/useConfig";
import ModalComponent from "../../components/ModalComponent.vue";
import LoadingScreen from "../../components/LoadingScreen.vue";
import mediaApi from "../../api/media";
import { ref } from "@vue/reactivity";
import dayjs from "dayjs";
import useError from "../../hooks/useError";
import useValidation from "../../hooks/useValidation";
import CopyButton from '../../components/CopyButton.vue';
export default {
  name: "EventPage",
  components: {
    IonPage,
    IonContent,
    EventForm,
    EventPageSidebar,
    ModalComponent,
    LoadingScreen,
    CopyButton,
  },
  watch: {
    event(newEvent) {
      if (
        newEvent?.attributes?.Status &&
        newEvent?.attributes?.Status !== "draft"
      ) {
        this.toActiveEvent();
      }
    },
  },
  computed: {
    formTracker() {
      return [
        { label: "Név", checked: !this.trackerErrors.name },
        { label: "Borító kép", checked: !this.trackerErrors.cover },
        {
          label: "Időpont",
          checked:
            !this.trackerErrors["date.startDate"] &&
            !this.trackerErrors["date.endDate"] &&
            !this.trackerErrors["date.startTime"] &&
            !this.trackerErrors["date.endTime"],
        },
        { label: "Helyszín", checked: !this.trackerErrors["location.Title"] },
        { label: "Árak", checked: !this.trackerErrors["price.net"] && !this.trackerErrors["price.gross"] },
        {
          label: "Létszám adatok",
          checked:
            !this.trackerErrors["headcount.min"] &&
            !this.trackerErrors["headcount.max"],
        },
        { label: "Leírás", checked: !this.trackerErrors["description"] },
        { label: "Az esemény tartalmazza", checked: !this.trackerErrors.tags },
        { label: "Elérhető extrák", checked: !this.trackerErrors.extras },
        { label: "A program borai", checked: !this.trackerErrors.wines },
        {
          label: "Közösségi média esemény link",
          checked: !this.trackerErrors.link,
        },
      ];
    },
  },
  setup() {
    const router = useRouter();
    const { params } = useRoute();
    const eventId = ref(params.eventId);
    const eventNID = ref(null)
    const wineryId = params.wineryId;
    const { config, loading: loadingConfig } = useConfig();
    const { winery, loading: loadingWinery } = useWinery(wineryId);
    const {
      loading: loadingEvent,
      event,
      update,
      getEvent,
      error: eventError,
    } = useEvent(eventId.value);

    const trackerRules = {
      name: [{ validator: "required" }],
      cover: [{ validator: "required" }],
      "date.startDate": [{validator: "required"}],
      "date.endDate": [{ validator: "required" }],
      "date.startTime": [{ validator: "required" }],
      "date.endTime": [{ validator: "required" }],
      "location.Title": [{ validator: "required" }],
      "price.net": [
        { validator: "required" },
        { validator: "number", params:{min:1} }  
      ],
      "headcount.min": [{ validator: "required" }],
      "headcount.max": [
        { validator: "required" },
        { validator: "number", params:{min:1}},
        { validator: "number", params:{min:"headcount.min"} }
      ],
      description: [{ validator: "required" }],
      tags: [{ validator: "required" }, { validator: "notempty" }],
      extras: [{ validator: "required" }, { validator: "notempty" }],
      wines: [{ validator: "required" }],
      link: [{ validator: "required" }],
    };
    const { errors: trackerErrors, validate: validateTracker } =
      useValidation(trackerRules);

    const newEventModalVisible = ref(false);
    const goBackModalVisible = ref(false);
    const eventName = ref(event?.attributes?.Name || "");
    const loadingSave = ref(false);

    // TRACK IF FORM IS IN PREVIEW MODE TO HIDE SIDEBAR INFO
    const formMode = ref("form");

    const setNewEventModal = (status) => {
      newEventModalVisible.value = status;
    };

    const handleBack = () => {
      router.push({ name: "EventsPage", params: { ...params } });
    };

    const handleChange = (formData, selectedMedia) => {
      eventName.value = formData.name;
      validateTracker({
        ...formData,
        cover: selectedMedia || formData.cover,
      });
    };

    const toActiveEvent = () => {
      router.replace({ name: "ActiveEventPage", params: { ...params } });
    };

    const toEventsPage = async () => {
      setNewEventModal(null);
      router.replace({
        name: "EventsPage",
        params: { ...params },
      });
    };

    const handleRemoveCover = async () => {
      await update({
        status: event.value.attributes.Status,
        cover: null,
      });
      await getEvent();
    };

    // To be able to call submit from here
    const triggerSubmit = ref(0);

    const handleSubmit = async (formData, selectedMedia, status) => {
      // MEDIA DATA
      delete formData.cover;

      loadingSave.value = true;
      var _formData = { ...formData };
      _formData.tags = _formData.tags?.map((tag) => tag.value);
      _formData.extras = _formData.extras?.map((extra) => extra.value);
      _formData.status = status;
      _formData.startAt = _formData.date.startDate && _formData.date.startTime ? dayjs(_formData.date.startDate)
        .hour(_formData.date.startTime.split(":")[0])
        .minute(_formData.date.startTime.split(":")[1])
        .second("00")
        .format(): undefined;
      _formData.endAt = _formData.date.endDate && _formData.date.endTime? dayjs(_formData.date.endDate)
        .hour(_formData.date.endTime.split(":")[0])
        .minute(_formData.date.endTime.split(":")[1])
        .second("00")
        .format(): undefined;

      // SEND DATA
      const postData = async () => {
        if (eventId.value && eventId.value !== "new") {
          return await update(_formData);
        } else {
          return await eventApi.add(_formData);
        }
      };
      const res = await postData();

      if (res.ok) {
        eventId.value = res.data.data.documentId;
        eventNID.value = res.data.data.attributes.NID

        // UPLOAD MEDIA
        if (selectedMedia) {
          var mediaData = new FormData();
          // mediaData.append("ref", "api::event.event");
          // mediaData.append("refId", res.data.data.documentId);
          // mediaData.append("field", "Cover");
          mediaData.append("files", selectedMedia);
          const mediaRes = await mediaApi.upload(mediaData);

          if (mediaRes.ok) {
            // UPDATE EVENT WITH MEDIA ID
            await eventApi.update({
              status: status,
              Cover: mediaRes.data[0].id,
            }, eventId.value);
            // TOGGLE MODAL
            setNewEventModal(status);
          }
        } else {
          setNewEventModal(status);
        }
      } else {
        eventError.value = useError(
          res,
          "Hiba történt az esemény létrehozásakor!"
        );
      }
      loadingSave.value = false;
    };

    return {
      trackerErrors,
      handleBack,
      handleChange,
      handleSubmit,
      handleRemoveCover,
      newEventModalVisible,
      goBackModalVisible,
      setNewEventModal,
      toEventsPage,
      event,
      eventName,
      loadingEvent,
      winery,
      loadingWinery,
      loadingSave,
      config,
      loadingConfig,
      toActiveEvent,
      eventError,
      triggerSubmit,

      formMode,
      eventNID,
    };
  },
};
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: row;
}
.header {
  padding: 24px 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: inset 0px -1px 0px #dddddd;
}
.event-page-sidebar {
  width: 268px;
  display: block;
  position: fixed;
  left: 0px;
  top: 88px;
  height: 100vh;
}
.event-page-content {
  /* flex: 1; */
  margin: 48px 32px;
  width: calc(100vw - 268px);
  margin-left: 300px;
}
</style>